module.exports = __webpack_public_path__ + "img/34_07.4d87ed58.png";